export default __webpack_public_path__ + "static/media/chevron-right-grey.eafbeca7.svg";